// Operators — experienced CEOs building inside the Govil Ventures model.
// Bios below are placeholder copy and can be swapped for each operator's exact
// wording later. Photos: Terry has a real portrait; others use a monogram until
// real headshots are provided.

export const OPERATORS = [
  {
    slug: "terry-dohrmann",
    name: "Terry Dohrmann",
    role: "CEO",
    company: "Lexafide",
    companyTag: "Legal Technology",
    image: "/terry.jpg",
    linkedin: "https://www.linkedin.com/in/terence-dohrmann-256a794/",
    detail: true,
    short:
      "Spent a career inside enterprise legal operations \u2014 now building the tooling he always wished he had.",
    quote:
      "Rab believed in me to be CEO before I fully believed in myself. He helped me find the cofounders who could turn my vision into a company.",
    focus: [
      "Enterprise legal operations",
      "Regulated workflows",
      "Go-to-market with existing relationships",
    ],
    bio: [
      "Terry spent years inside enterprise legal, close enough to the work to name every bottleneck by heart. Lexafide began the day he decided to stop working around those bottlenecks and start removing them.",
      "Govil Ventures provided the operating company and the technology repository. Terry provided the judgment and the distribution \u2014 the two things that can\u2019t be bought. Lexafide was in market before most teams finish hiring.",
    ],
  },
  {
    slug: "brian-tuite",
    name: "Brian Tuite",
    role: "CEO",
    company: "Zenarate",
    companyTag: "Real Estate \u00b7 AI",
    image: "/brian.jpg",
    linkedin: "https://www.linkedin.com/in/briantuite/",
    short:
      "A builder who reads real-estate feasibility the way few can \u2014 turning decades of pattern into an AI-native product.",
    quote:
      "The instinct took twenty years to build. The product to express it took months, because I didn\u2019t have to build the company around it too.",
    focus: [
      "Real-estate feasibility",
      "AI-native product design",
      "Operating discipline at speed",
    ],
    bio: [
      "Brian has spent a career learning where real-estate projects quietly succeed or fail long before a shovel hits the ground. That instinct is the product Zenarate is built around.",
      "We assembled engineers and designers around his judgment, and Zenarate shipped AI-driven feasibility in a fraction of the usual time \u2014 built this way from the first line of code.",
    ],
  },
  {
    slug: "chris-doyle",
    name: "Chris Doyle",
    role: "CEO",
    company: "Stellaforce",
    companyTag: "Enterprise \u00b7 Workforce",
    image: "/chris.jpg",
    linkedin: "https://www.linkedin.com/in/chris-doyle-031a462/",
    short:
      "Has made the hard workforce decisions for years \u2014 now building the company that makes them easier for everyone else.",
    quote:
      "You only learn where teams break by being responsible when they do. That scar tissue is the whole thesis of Stellaforce.",
    focus: [
      "Workforce strategy",
      "Scaling critical teams",
      "Enterprise operating experience",
    ],
    bio: [
      "The best workforce decisions come from people who have made the hard ones. Chris built and scaled critical teams for years before Stellaforce, and that lived experience is the foundation the company stands on.",
      "He brought the two things we can\u2019t buy. We\u2019d already built the other four. Stellaforce is the company that combination makes possible.",
    ],
  },
];

export const getOperator = (slug) => OPERATORS.find((o) => o.slug === slug);
